export default {"src":"/_next/static/media/thor_icon.43c81fef.svg","height":49,"width":16,"blurWidth":0,"blurHeight":0};